import { SET_UPDATE_PROJECT } from "../../constants";

export const updateProject = (UpdateProject: any = {}) => ({
  type: SET_UPDATE_PROJECT,
  payload: UpdateProject,
});
